export default {
    APLICACAO: 1,
    ATUALIZACAO: 2,
}
